export enum SituacaoConsignadoTableLabel {
  ABERTO = "SKU's abertos",
  SIMBOLICO = "SKU's devolvidos simbolicamente",
  DIVERGENTE = "SKU's com divergencia da devolução do cliente",
}

export enum SituacaoConsignado {
  ABERTO = "ABERTO",
  PARCIAL = "PARCIAL",
  CONSIGNADO = "CONSIGNADO",
  CANCELADO = "CANCELADO",
  VENDIDO = "VENDIDO",
  DIVERGENTE = "DIVERGENTE",
  SIMBOLICO = "SIMBOLICO",
  FECHADO = "FECHADO",
}

export class SituacaoConsignadoClass {
  private readonly _situacao: SituacaoConsignado;

  private constructor(situacao: SituacaoConsignado) {
    this._situacao = situacao;
  }

  public static of(situacao: SituacaoConsignado) {
    return new SituacaoConsignadoClass(situacao);
  }

  public isAberto() {
    return this._situacao === SituacaoConsignado.ABERTO;
  }

  public isParcial() {
    return this._situacao === SituacaoConsignado.PARCIAL;
  }

  public isDivergente() {
    return this._situacao === SituacaoConsignado.DIVERGENTE;
  }

  public isConsignado() {
    return this._situacao === SituacaoConsignado.CONSIGNADO;
  }

  public isCancelado() {
    return this._situacao === SituacaoConsignado.CANCELADO;
  }

  public isVendido() {
    return this._situacao === SituacaoConsignado.VENDIDO;
  }

  public isSimbolico() {
    return this._situacao === SituacaoConsignado.SIMBOLICO;
  }

  public isFechado() {
    return this._situacao === SituacaoConsignado.FECHADO;
  }

  public possuiConsignado() {
    return this.isConsignado() || this.isParcial();
  }

  public permiteCancelar() {
    return this.isAberto();
  }

  public permiteGerenciar() {
    return this.isAberto() || this.isParcial() || this.isConsignado();
  }

  public permiteEstornoDevolucao() {
    return !this.isFechado() && !this.isCancelado() && !this.isVendido();
  }

  public isConsideraParaValorAberto() {
    return this.isAberto() || this.isDivergente() || this.isSimbolico();
  }
}
